<cb-confirmation
                 headerTitle="{{headerTitle}}"
                 confirmationTitle="{{confirmationTitle}}"
                 confirmationMessage="{{confirmationMessage}}"
                 linkText="{{linkText}}"
                 linkRouterPath="{{linkRouterPath}}">
</cb-confirmation>

